// 🛡️ Role names
export const ROLES = {
  NONIUS_ADMIN: "nonius-admin",
  NONIUS_ENGINEER: "nonius-engineer",
  NONIUS_TECHNICAL: "nonius-technical",
  CLIENT_TECH: "client-tech",
  CLIENT_ADMIN: "client-admin",
  CLIENT_BRAND_MANAGER: "client-brand-manager",
  CLIENT_EVENTS_MANAGER: "client-events-manager",
  CLIENT_SALES_MANAGER: "client-sales-manager",
};

// 🎨 Role Color Palette
export const ROLE_COLORS = {
  [ROLES.NONIUS_ADMIN]: "#0059CC",
  [ROLES.NONIUS_ENGINEER]: "#FF3333",
  [ROLES.NONIUS_TECHNICAL]: "#688B41",
  [ROLES.CLIENT_TECH]: "#FF7231",
  [ROLES.CLIENT_ADMIN]: "#535379",
  [ROLES.CLIENT_BRAND_MANAGER]: "#7B7D1C",
  [ROLES.CLIENT_EVENTS_MANAGER]: "#FFDDB3",
  [ROLES.CLIENT_SALES_MANAGER]: "#776D55",
};

// 🔒 Permission Mapping
export const PERMISSIONS = {
  conferences: [ROLES.CLIENT_ADMIN, ROLES.NONIUS_ADMIN, ROLES.CLIENT_EVENTS_MANAGER, ROLES.CLIENT_SALES_MANAGER],
  scheduler: [ROLES.CLIENT_ADMIN, ROLES.NONIUS_ADMIN, ROLES.CLIENT_EVENTS_MANAGER, ROLES.CLIENT_SALES_MANAGER],
  presentations: [ROLES.CLIENT_ADMIN, ROLES.NONIUS_ADMIN, ROLES.CLIENT_EVENTS_MANAGER, ROLES.CLIENT_BRAND_MANAGER, ROLES.CLIENT_SALES_MANAGER],
  templates: [ROLES.CLIENT_ADMIN, ROLES.NONIUS_ADMIN, ROLES.CLIENT_BRAND_MANAGER],
  players: [ROLES.CLIENT_ADMIN, ROLES.NONIUS_ADMIN, ROLES.CLIENT_SALES_MANAGER, ROLES.NONIUS_TECHNICAL, ROLES.CLIENT_TECH, ROLES.NONIUS_ENGINEER],
  media: [ROLES.CLIENT_ADMIN, ROLES.NONIUS_ADMIN, ROLES.CLIENT_EVENTS_MANAGER, ROLES.CLIENT_BRAND_MANAGER, ROLES.CLIENT_SALES_MANAGER],
  diagnostics: [ROLES.CLIENT_ADMIN, ROLES.NONIUS_ADMIN, ROLES.NONIUS_ENGINEER],
  software: [ROLES.NONIUS_ADMIN, ROLES.NONIUS_TECHNICAL, ROLES.CLIENT_TECH, ROLES.NONIUS_ENGINEER],
  analytics: [ROLES.NONIUS_ADMIN, ROLES.NONIUS_TECHNICAL, ROLES.CLIENT_TECH, ROLES.NONIUS_ENGINEER],
  settings: [ROLES.CLIENT_ADMIN, ROLES.NONIUS_ADMIN, ROLES.CLIENT_BRAND_MANAGER, ROLES.CLIENT_SALES_MANAGER, ROLES.NONIUS_TECHNICAL, ROLES.CLIENT_TECH, ROLES.NONIUS_ENGINEER],
};